import styled from '@emotion/styled/macro';
import { PUBLIC_URL } from '../../../config';

export const BackgroundImage = styled.div`
    background-image: url('${PUBLIC_URL}/img/event/cheltenham-background.jpg');
    background-repeat: no-repeat;
    background-position-y: top;
    background-position-x: right;
    background-size: cover;
    width: 100%;
    height: 250px;
    display: block;
    margin-bottom: 16px;
    
    @media (max-width: 600px) {
        background-position-x:right -135px;
    }
`;

export const Wrapper = styled.div`
    display: flex;
    margin: 0 auto;
    height: 100%;
`;

export const TextContent = styled.div`
    width: fit-content;
    height: fit-content;
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    border-radius: 4px;

    @media (max-width: 1023px) {
        background: none;
        box-shadow: none;
        padding: 0;
    }
`;

export const Title = styled.h1`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProBold};
    font-size: ${props => props.theme.fontSize.xlarge};
    margin-bottom: 24px;
    text-align: center;
    text-transform: uppercase;
`;

export const Prize = styled.img`
    display: block;
    width: 100%;
    max-width: 350px;
    height: auto;
    margin: 20px 0 16px 0;
    padding-right: 400px;

    @media (max-width: 800px) {
        padding-right: 100px;
    }

    @media (max-width: 500px) {
        max-width: 250px;
    }
`;
